import { post } from ".";
import { serviceRouteConstants } from "../Constants/routingConstants";
import { getSystemAllRequestsForExport } from "../utilities/utils";

export const _exportAppliedCandidates = async (data) => {
  let applicantIds = data.applicant_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "applicant_ids",
    applicantIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportApplied,
    data: postData,
  };
  return await post(request);
};

export const _exportContractShifts = async (data) => {
  let contractIds = data.contract_ids;
  let parentContractId = data.parent_contract_id;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );
  if (postData) {
    postData.parent_contract_id = parentContractId;

    const request = {
      endPoint: serviceRouteConstants.exportContractShifts,
      data: postData,
    };
    return await post(request);
  }
  //   return null;
};

export const _exportContractTerminatedShifts = async (data) => {
  let contractIds = data.contract_ids;
  let parentContractId = data.parent_contract_id;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );
  if (postData) {
    postData.parent_contract_id = parentContractId;

    const request = {
      endPoint: serviceRouteConstants.exportContractTerminatedShifts,
      data: postData,
    };
    return await post(request);
  }
  //   return null;
};

export const _exportCandidateWorkedHistory = async (data) => {
  let contractIds = data.contract_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportCandidateWorkedHistory,
    data: postData,
  };
  return await post(request);
};

export const _exportCandidateUpcomingBooking = async (data) => {
  let contractIds = data.contract_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportCandidateUpcomingBooking,
    data: postData,
  };
  return await post(request);
};

export const _exportBookedCandidates = async (data) => {
  let contractIds = data.contract_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportBooked,
    data: postData,
  };
  return await post(request);
};

export const _exportWorkedCandidates = async (data) => {
  let contractIds = data.contract_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportWorked,
    data: postData,
  };
  return await post(request);
};

export const _exportUnfilledContracts = async (data) => {
  let contractIds = data.contract_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "contract_ids",
    contractIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportUnfilled,
    data: postData,
  };
  return await post(request);
};

export const _exportAuthorisedTimesheets = async (data) => {
  let timesheetIds = data.timesheet_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "timesheet_ids",
    timesheetIds,
  );

  const request = {
    endPoint: serviceRouteConstants.exportAuthorised,
    data: postData,
  };
  return await post(request);
};

export const _exportTerminatedTimesheets = async (data) => {
  let timesheetIds = data.timesheet_ids;
  let postData = getSystemAllRequestsForExport(
    data,
    "timesheet_ids",
    timesheetIds,
  );
  const request = {
    endPoint: serviceRouteConstants.exportTerminated,
    data: postData,
  };
  return await post(request);
};

export const _exportCandidatePayInvoice = async (data) => {
  let invoice_id = data?.invoice_id;
  let postData = getSystemAllRequestsForExport(data, "invoice_id", invoice_id);

  const request = {
    endPoint: serviceRouteConstants.exportCandidatePayInvoice,
    data: postData,
  };
  return await post(request);
};

export const _exportAppLocumInvoice = async (data) => {
  let invoice_id = data?.invoice_id;
  let postData = getSystemAllRequestsForExport(data, "invoice_id", invoice_id);
  const request = {
    endPoint: serviceRouteConstants.exportAppLocumInvoice,
    data: postData,
  };
  return await post(request);
};
